import React, {Component} from "react";
import styles from './FJPreviewVolumeView.module.less';
import FJIconButton from "../../../../../common/component/button-icon/FJIconButton";
import VolumeIcon from '../../../../../icon/stock-volume.svg';
import InlineSVG from "react-inlinesvg";
import FJDropDown from "fj-components/FJDropDown";
import FJSlider from "fj-components/FJSlider";
import MuteIcon from '../../../../../icon/mute.svg';

const ForwardTrigger = React.forwardRef((props, ref) => (
	<FJIconButton  icon={<InlineSVG src={props.mute ? MuteIcon : VolumeIcon} />} className={styles.volume_container} forwardRef={ref}/>
));

class FJPreviewVolumeView extends Component{

	constructor(props) {
		super(props);

		this.state = {
			progress: 1
		}

		this.slider =  {
			sliderBoxClassName: styles.slider_box,
			railClassName: styles.rail,
			trackClassName: styles.track,
			handleClassName: styles.handle,
		}
	}

	_triggerChange = (type, progress) => {
    this.setState({
      progress
    }, () => {
      this.props.setVideoVolume(type, progress)
    });
  };

	_onChange = (value, progress) => {
		this._triggerChange('change', progress);
	}

	_onBeforeChange = (value, progress) => {
    this._triggerChange('changeStart', progress);
  };

	_onAfterChange = (value, progress) => {
    this._triggerChange('changeEnd', progress);
  };

	triggerClick = (e) => {
		e.target.blur();
	};


	render() {

		let {
			volume
		} = this.props;

		return (
			<FJDropDown overlay={
				<div>
					<div className={styles.slider_container}>
						<FJSlider progress={volume}
											vertical
											classes={this.slider}
											onChange={this._onChange}
                      onBeforeChange={this._onBeforeChange}
                      onAfterChange={this._onAfterChange}
						/>
					</div>
				</div>
			}
									placement='topCenter'
									overlayClassName={styles.volume_overlay}
									triggerClick={this.triggerClick}
									propsTop={-24}
                  isTopLayer
			>
				<ForwardTrigger mute={volume === 0}/>
			</FJDropDown>
		)
	}

}


export default FJPreviewVolumeView;
